module.exports = __webpack_public_path__ + "static/zqb3_12.7fa1eaf5.jpg";